__turbopack_context__.v({
  "dropBadge": "styles-module-scss-module__J4SEda__dropBadge",
});
